import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Card,
  Badge,
  ListGroup,
  Spinner,
  Alert,
  Button,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";
import {
  getFormQuestions,
  // editFormQuestion,
  createFormQuestion,
  changeQuestionStatus,
} from "../../../redux/capacitacionDesarrollo/DNC/actions";

function DNCForm() {
  const [show, setShow] = useState(true);
  const [showModal, setShowModal] = useState(false);
  // const [currentQuestion, setCurrentQuestion] = useState(null);
  const [options, setOptions] = useState([{ texto: "" }]);
  const [formData, setFormData] = useState({
    tipoPregunta: "",
  });
  const [errors, setErrors] = useState({
    textoPregunta: "",
    tipoPregunta: "",
    options: [],
  });
  const dispatch = useDispatch();

  // Store
  const { username } = useSelector((store) => store.auth);
  const { loading, saveLoading, formQuestions, error } = useSelector((store) => store.DNC);
  const onShowSidebar = () => setShow(!show);

  useEffect(() => {
    dispatch(getFormQuestions());
  }, [dispatch]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      textoPregunta: "",
      tipoPregunta: "",
      options: [],
    };

    if (!formData.textoPregunta || formData.textoPregunta.trim() === "") {
      newErrors.textoPregunta = "El campo de texto para la pregunta es obligatorio";
      isValid = false;
    }

    if (!formData.tipoPregunta) {
      newErrors.tipoPregunta = "Debe seleccionar un tipo de pregunta";
      isValid = false;
    }

    if (formData.tipoPregunta?.includes("seleccion")) {
      const optionsErrors = [];
      let hasOptionError = false;
      
      options.forEach((option, index) => {
        if (!option.texto || option.texto.trim() === "") {
          optionsErrors[index] = "La opción no puede estar vacía";
          hasOptionError = true;
        } else {
          optionsErrors[index] = "";
        }
      });

      if (hasOptionError) {
        newErrors.options = optionsErrors;
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleOpenModal = () => {
    setOptions([{ texto: "" }]);
    setFormData({ 
      tipoPregunta: "",
      textoPregunta: "",
      obligatoria: false 
    });
    setErrors({
      textoPregunta: "",
      tipoPregunta: "",
      options: [],
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // setCurrentQuestion(null);
    setOptions([{ texto: "" }]);
    setFormData({ 
      tipoPregunta: "",
      textoPregunta: "",
      obligatoria: false 
    });
    setErrors({
      textoPregunta: "",
      tipoPregunta: "",
      options: [],
    });
  };

  const handleAddOption = () => {
    setOptions([...options, { texto: "" }]);
    setErrors({
      ...errors,
      options: [...errors.options, ""]
    });
  };

  const handleRemoveOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
    
    const newErrors = [...errors.options];
    newErrors.splice(index, 1);
    setErrors({ ...errors, options: newErrors });
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index].texto = value;
    setOptions(newOptions);
    
    if (value.trim() !== "" && errors.options[index]) {
      const newErrors = [...errors.options];
      newErrors[index] = "";
      setErrors({ ...errors, options: newErrors });
    }
  };

  const handleStatusChange = (questionId) => {
    dispatch(
      changeQuestionStatus({ codigo_empleado: username }, questionId)
    ).then(() => dispatch(getFormQuestions()));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    const questionData = {
      codigo_empleado: username,
      texto: formData.textoPregunta,
      tipo: formData.tipoPregunta,
      obligatoria: formData.obligatoria,
    };

    if (questionData.tipo !== "texto") {
      questionData.opciones = options.filter((opt) => opt.texto.trim() !== "");
    }

    dispatch(createFormQuestion(questionData)).then(() => {
      dispatch(getFormQuestions());
      handleCloseModal();
    });
  };

  const renderQuestionCard = (question) => {
    return (
      <Card key={question.id} className="mb-3">
        <Card.Body>
          <div className="d-flex justify-content-between">
            <div>
              <Card.Title>
                {question.texto}
                {question.obligatoria && (
                  <Badge pill bg="danger" className="ms-2">
                    Obligatoria
                  </Badge>
                )}
                {question.activa ? (
                  <Badge pill bg="success" className="ms-2">
                    Activa
                  </Badge>
                ) : (
                  <Badge pill bg="secondary" className="ms-2">
                    Inactiva
                  </Badge>
                )}
              </Card.Title>
              <Card.Subtitle className="mb-2 text-muted">
                Tipo: {question.tipo.replace("_", " ")}
              </Card.Subtitle>

              {question.opciones && question.opciones.length > 0 && (
                <ListGroup variant="flush" className="mb-3">
                  {question.opciones.map((opcion, idx) => (
                    <ListGroup.Item key={idx}>{opcion.texto}</ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </div>
            <div className="d-flex flex-column gap-2">
              {/* Comentamos el botón de edición
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`edit-tooltip-${question.id}`}>Editar pregunta</Tooltip>}
              >
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleOpenModal(question)}
                >
                  <i className="material-icons">edit</i>
                </Button>
              </OverlayTrigger>
              */}
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`status-tooltip-${question.id}`}>
                    {question.activa ? "Desactivar pregunta" : "Activar pregunta"}
                  </Tooltip>
                }
              >
                <Button
                  variant={question.activa ? "outline-danger" : "outline-success"}
                  size="sm"
                  onClick={() => handleStatusChange(question.id)}
                >
                  <i className="material-icons">
                    {question.activa ? "toggle_off" : "toggle_on"}
                  </i>
                </Button>
              </OverlayTrigger>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCapacitacion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">Formulario DNC</h5>
            <Button
              variant="primary"
              size="sm"
              className="rounded-pill"
              onClick={handleOpenModal}
            >
              <i className="material-icons">add</i> Nueva Pregunta
            </Button>
          </div>

          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}

          <div className="mt-4">
            {loading ? (
              <div className="text-center my-5">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <div>
                {formQuestions &&
                formQuestions.preguntas &&
                formQuestions.preguntas.length > 0 ? (
                  formQuestions.preguntas.map(renderQuestionCard)
                ) : (
                  <Card>
                    <Card.Body className="text-center">
                      No hay preguntas disponibles
                    </Card.Body>
                  </Card>
                )}
              </div>
            )}
          </div>
        </Container>
      </div>

      {/* Modal para agregar preguntas */}
      <Modal centered show={showModal} onHide={handleCloseModal}>
        <Form onSubmit={handleSubmit} noValidate>
          <Modal.Header closeButton>
            <Modal.Title>
              Añadir nueva pregunta al formulario
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nueva Pregunta</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Escribe la pregunta aquí"
                name="textoPregunta"
                value={formData.textoPregunta || ""}
                onChange={handleInputChange}
                isInvalid={!!errors.textoPregunta}
              />
              <Form.Control.Feedback type="invalid">
                {errors.textoPregunta}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Tipo de pregunta</Form.Label>
              <Form.Control
                as="select"
                className="rounded-pill"
                name="tipoPregunta"
                value={formData.tipoPregunta}
                onChange={(e) => {
                  const newTipo = e.target.value;
                  setFormData({ ...formData, tipoPregunta: newTipo });
                  if (!newTipo.includes("seleccion")) {
                    setOptions([{ texto: "" }]);
                    setErrors({ ...errors, options: [] });
                  }
                  
                  if (errors.tipoPregunta) {
                    setErrors({ ...errors, tipoPregunta: "" });
                  }
                }}
                isInvalid={!!errors.tipoPregunta}
              >
                <option value="" disabled>
                  Seleccione el tipo de pregunta
                </option>
                <option value="seleccion_unica">Selección única</option>
                <option value="seleccion_multiple">Selección múltiple</option>
                <option value="texto">Texto libre</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.tipoPregunta}
              </Form.Control.Feedback>
            </Form.Group>

            {formData.tipoPregunta?.includes("seleccion") && (
              <Form.Group className="mb-3">
                <Form.Label>Opciones de respuesta</Form.Label>
                {options.map((option, index) => (
                  <div key={index} className="d-flex mb-2">
                    <div className="flex-grow-1">
                      <Form.Control
                        type="text"
                        placeholder={`Opción ${index + 1}`}
                        value={option.texto}
                        onChange={(e) =>
                          handleOptionChange(index, e.target.value)
                        }
                        isInvalid={!!errors.options[index]}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.options[index]}
                      </Form.Control.Feedback>
                    </div>
                    {options.length > 1 && (
                      <Button
                        variant="outline-danger"
                        className="ms-2"
                        onClick={() => handleRemoveOption(index)}
                      >
                        <i className="material-icons">remove</i>
                      </Button>
                    )}
                  </div>
                ))}
                <Button
                  variant="outline-primary"
                  size="sm"
                  type="button"
                  onClick={handleAddOption}
                >
                  <i className="material-icons">add</i> Agregar Opción
                </Button>
              </Form.Group>
            )}
            <Form.Group className="mb-3">
              <div className="d-flex gap-4">
                <Form.Check
                  type="checkbox"
                  id="obligatoria"
                  label="Pregunta obligatoria"
                  name="obligatoria"
                  checked={formData.obligatoria || false}
                  onChange={handleInputChange}
                />
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="primary" 
              type="submit"
              disabled={saveLoading}
            >
              {saveLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Creando...
                </>
              ) : (
                "Crear Pregunta"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default DNCForm;